// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import ClaimAction from '@deere/cps-it.warranty-model-factory/lib/claim-action';
import {FormattedMessage} from 'react-intl';
import {getPrimaryAction} from '../../../shared/services/claim-shared-helper';

const ClaimPrimaryAction = props => {

    const primaryAction = getPrimaryAction(props.actions);

    return primaryAction ?
        <button
            className='button-primary'
            disabled={props.isActionButtonDisabled}
            onClick={props.onActionClick.bind(null, primaryAction)}
        >
            <FormattedMessage id={primaryAction.actionName}/>
        </button> :
        null;

};

ClaimPrimaryAction.displayName = 'ClaimPrimaryAction';
ClaimPrimaryAction.propTypes = {
    actions: PropTypes.arrayOf(PropTypes.instanceOf(ClaimAction)).isRequired,
    isActionButtonDisabled: PropTypes.bool,
    onActionClick: PropTypes.func.isRequired
};
ClaimPrimaryAction.defaultProps = {
    isActionButtonDisabled: false
};

export default ClaimPrimaryAction;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-action-button/claim-primary-action.js